<template>
    <v-container style="height: 100%; width: 100%;" fluid class="pa-0 ma-0">
        <v-container color="#00FF00" class="pa-0 ma-0" style="width: 100%;" fluid>

            <v-toolbar id="exploretool" color="#FFA500" flat dense class="pb-0">
                <v-toolbar-items>
                    <v-btn text @click="setnavbar" color="black"><v-icon>menu</v-icon></v-btn>
                    <div class="pa-1 mx-5 black--text menuhead" text tile>SETTINGS</div>
                    <v-btn class="px-10" text tile v-bind:style="[togglepersonal ? {'background':'#FFD375', 'color':'black'} : {'color':'black'}]" @click='setMode("Personal")'>Personal</v-btn>
                    <v-btn class="px-10" text tile v-bind:style="[togglenotifications ? {'background':'#FFD375', 'color':'black'} : {'color':'black'}]" @click='setMode("Notifications")'>Notifications</v-btn>
                    <v-btn class="px-10" text tile v-bind:style="[toggleaccount ? {'background':'#FFD375', 'color':'black'} : {'color':'black'}]" @click='setMode("Account")'>Account</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container pa-0 ma-0 color="#0000FF" style="height: 95%; width: 100%;" >
                <component :is="detailvue"></component>
            </v-container>

        </v-container>
    </v-container>
</template>

<script>

import SettingsPersonal from '@/views/Settings/SettingsPersonal';
import SettingsNotifications from '@/views/Settings/SettingsNotifications';
import SettingsAccount from '@/views/Settings/SettingsAccount';

import '@/general.js';

export default {
    name: 'Settings',
    mounted:function(){
        this.$store.state.heading="Settings";
    },
    data() {
        return {        
            detailvue: '',  
            changed:false,
            togglepersonal: false,
            togglenotifications: false,
            toggleaccount:false
        };
    },
    components: {
        SettingsPersonal,
        SettingsNotifications,
        SettingsAccount
    },
    methods: {
        setnavbar() {
            if (this.changed)
                this.confirmChanged();
            else
                this.$store.state.navpage.setnavbar();
        },
        setMode(mode){
            this.detailvue = 'Settings' + mode;
            this.togglepersonal = false;
            this.togglenotifications = false;
            this.toggleaccount=false;
            if (mode === 'Personal') this.togglepersonal = true;
            if (mode === 'Notifications') this.togglenotifications = true;
            if (mode === 'Account') this.toggleaccount=true;
        }
    }
}

</script>

<style>
    .menuhead {
        font-size: 1.5em;
        font-weight: bold;
    }
</style>